module.exports = __webpack_public_path__ + "img/logo0.3b0c2526.png";